import { ReactNode, useState } from 'react';

import { MedicalDataAccessAuthorization } from '@dreryk/egabinet-patient-frontend-api';

import { TranslatableText } from '@dreryk/react-common';

import { MedicalDataAccessAuthorizationModal } from './MedicalDataAccessAuthorizationModal';
import {
   MedicalDataAccessAuthorizationFormBean,
   MedicalDataAccessAuthorizationFormValues,
} from './MedicalDataAccessAuthorizationModalForm/MedicalDataAccessAuthorizationModalForm.types';

type MedicalDataAccessAuthorizationOpenFormCreateActionProps = {
   readonly initialValues: MedicalDataAccessAuthorizationFormValues;
   readonly render: (openModal: () => void) => ReactNode;
   readonly onSubmit: (data: MedicalDataAccessAuthorizationFormBean) => Promise<MedicalDataAccessAuthorization>;
   readonly modalTitle: TranslatableText;
};

const MedicalDataAccessAuthorizationOpenFormAction = (
   props: MedicalDataAccessAuthorizationOpenFormCreateActionProps
): JSX.Element => {
   const [showModal, setShowModal] = useState(false);

   const openModal = (): void => {
      setShowModal(true);
   };

   const onSubmit = async (data: MedicalDataAccessAuthorizationFormBean): Promise<MedicalDataAccessAuthorization> => {
      const result = await props.onSubmit(data);
      setShowModal(false);
      return result;
   };

   const onCancel = (): void => {
      setShowModal(false);
   };

   return (
      <>
         {props.render(openModal)}
         {showModal ? (
            <MedicalDataAccessAuthorizationModal
               initialValues={props.initialValues}
               onSubmit={onSubmit}
               onCancel={onCancel}
               modalTitle={props.modalTitle}
            />
         ) : null}
      </>
   );
};

export { MedicalDataAccessAuthorizationOpenFormAction };
